import React from 'react';
import PropTypes from 'prop-types';

function TableHeader({ column }) {
  return <th {...column.getHeaderProps()}>{column.render('Header')}</th>;
}

TableHeader.propTypes = {
  children: PropTypes.node,
};

export default TableHeader;
